import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconGroup(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M8 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8ZM7 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 15a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.9 3h16.2c.4 0 .9.4.9.9v16.2c0 .4-.5.9-.9.9H3.9c-.5 0-.9-.5-.9-.9V3.9c0-.5.4-.9.9-.9ZM19 5H5v14h14V5Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
